import React from 'react';

import { Box, Chip } from '@mui/material';

import ListPage from '../../../sharedModules/listPage/ListPage';

const NotificationSettingsListPage: React.FC = () => {
  const notificationSettingColumns = [
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
      wrap: true,
      grow: 2,
    },
    {
      name: 'Module',
      selector: 'app_module_name',
      sortable: true,
      width: '200px',
      cell: (row: any) => row.app_module_name || <em style={{ color: '#999' }}>All Modules</em>,
    },
    {
      name: 'Recipients',
      selector: (row: any) => row.users?.length || 0,
      sortable: true,
      grow: 3,
      cell: (row: any) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: 1 }}>
          {row.users && row.users.length > 0 ? (
            row.users.map((user: any) => (
              <Chip key={user.id} label={user.name} size="small" color="primary" variant="outlined" />
            ))
          ) : (
            <em style={{ color: '#999' }}>No recipients</em>
          )}
        </Box>
      ),
    },
  ];

  return (
    <ListPage
      clickableRows
      columns={notificationSettingColumns}
      controller="admin/notification_settings"
      queryPlaceholder="Filter by name..."
      title="Notification Settings"
    />
  );
};

export default NotificationSettingsListPage;
